import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Language')
export class Language {

  @JsonProperty('language_id', Number)
  languageId: number = 0;

  @JsonProperty('language_iso', String)
  languageIso: string = '';

  @JsonProperty('revision', Number)
  revision: number = 0;

  @JsonProperty('translations_missing_count', Number)
  translationsMissingCount: number = 0;

  @JsonProperty('is_active', Boolean)
  isActive: boolean = false;
}
